import { Suspense, useRef, useState } from "react";
import { useEffect } from "react";
import { getGroups, getLiveViewCameras, listSitesWithLiveView } from '../../Api Methods/Api'
import { useDispatch, useSelector } from "react-redux";
import classes from './liveViewSites.module.css'
import Modal from "../../components/Modal/Modal";
import ListCard from "../../components/GridList/ListCard";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { Dropdown } from "primereact/dropdown";
import { Await, Link, useLoaderData, useLocation, useNavigate } from "react-router-dom";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import useSetCookie from "../../components/hooks/UseSetCookie";
import OutputPinCircle from "../../components/UI/DataLayouts/OutputPinCircle";
import InputPinCircle from "../../components/UI/DataLayouts/InputPinCircle";
import BasicTable from "../../components/Table/Table/Table";
import Stats2 from "../../components/UI/Stats/Stats2";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import { Button } from "primereact/button";
import { format } from "date-fns";
import { serviceActions } from "../../store/service-Slice";
import DataManager from "../../hooks/DataManager";
import DevicesList from "../../components/GridList/DevicesList";
import { off } from "rsuite/esm/DOMHelper";

const SiteCameras = () => {

    const { cameras }  = useLoaderData();
    const { state } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    localStorage.removeItem('DeviceUUID')
    const apiData = {
        token,
        client
    }
    const ModalDialog = useRef();
    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()
    const loggedInAs = useSelector(state => state.auth.companyName);
    const [isLoading, setIsLoading] = useState(false)

    const dataManager = new DataManager();

    const [visibleDevices, setVisibleDevices] = useState([]);
    const [page, setPage] = useState(0)



    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        //setSelectedMassAction("")
    }

    const HandleUipiodOnClick = (DeviceUUID) => {
        dispatch(serviceActions.setDeviceUUID(DeviceUUID));
        useSetCookie("DeviceUUID", DeviceUUID, 1);
        navigate("/Dashboard/SiteView/" + DeviceUUID);
   }


    let tableColumns = [
        {
          id: 'type',
          header: () => (
            <div className={classes.tableTitleText}>
              <h3>Camera type</h3>
            </div>
          ),
          filterLabel: "Camera type",
          accessorKey: 'type',
          cell: (row) => {
            return (
              <div onClick={() => HandleUipiodOnClick(state.uuid)} className={classes.tableValueText}>
                {}
                {row.row.original.type != null ? <Pill_Widget 
                          boolean={true} 
                          PillColor_IfTrue={"#3d6ed9"} 
                          PillColor_IfFalse={"#dc7277"} 
                          text_IfTrue={row.row.original.type}
                          text_IfFalse={"No"}
                          className={classes.PillHeight} /> 
                          
                          : 
                          
                          <Pill_Widget 
                          boolean={true} 
                          PillColor_IfTrue={"#ff2424"} 
                          PillColor_IfFalse={"#dc7277"} 
                          text_IfTrue={"No cameras linked"}
                          text_IfFalse={""}
                          className={classes.PillHeight} />
                          
                          }
                </div>
            )
          }
        },
        {
          id: 'cameraName',
          header: () => (
            <div className={classes.tableTitleText}>
              <h3>Camera name</h3>
            </div>
          ),
          filterLabel: "Camera type",
          accessorKey: 'type',
          cell: (row) => {
            return (
                
              <div onClick={() => HandleUipiodOnClick(state.uuid)} className={classes.tableValueTextBold}>
                { row.row.original.name }
              </div>
            )
          }
        },

          {
            id: 'linkedDate',
            header: () => (
              <div className={classes.tableTitleText}>
                <h3>Date linked</h3>
              </div>
            ),
            filterLabel: "DateLinked",
            accessorKey: 'dateLinked',
            cell: (row) => {
              const formattedDate =
                isNaN(new Date(row.row.original.dateAdded)) || 
                !row.row.original.dateAdded 
                  ? row.row.original.dateAdded 
                  : format(new Date(row.row.original.dateAdded), "MMMM do, yyyy - HH:mm");
              return (
                <div onClick={() => HandleUipiodOnClick(state.uuid)} className={classes.tableValueText}>
                  {formattedDate}
                </div>
              )
            }
          },
          // {
          //   id: 'linkedby',
          //   header: () => (
          //     <div className={classes.tableTitleText}>
          //       <h3>Linked by</h3>
          //     </div>
          //   ),
          //   filterLabel: "LinkedBy",
          //   accessorKey: 'linkedBy',
          //   cell: (row) => {
          //     return (
          //       <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
          //         {row.row.original.addedBy}
          //       </div>
          //     )
          //   }
          // },
          {
            id: 'pinned',
            header: () => (
              <div className={classes.tableTitleText}>
                <h3>Pinned camera</h3>
              </div>
            ),
            filterLabel: "Pinned",
            accessorKey: 'pinned',
            cell: (row) => {
              return (
                <div onClick={() => HandleUipiodOnClick(state.uuid)} className={classes.tableValueText}>
                  {
                    row.row.original.defaultPinned != null ? (row.row.original.defaultPinned == 1 ? "Yes" : "No") : ""
                  }
                </div>
              )
            }
          }
        ];
  

    return (
      <Await resolve={cameras}>
        {(loadedSites) => {
          return (
            <>
              <div style={{ width: "100%"}}>
                <div className={classes.container}>
                    <Stats2
                    title={"Site ID"}
                    value={state.key}
                    isLoadingStats={isLoading}
                    isStatic={true}
                    />

                    <Stats2
                    title={"Portal site name "}
                    value={state.tag}
                    isLoadingStats={isLoading}
                    isStatic={true}
                    />

                    <Stats2
                    title={"Status"}
                    value={state.online === "YES" ? "Online" : "Offline"}
                    isLoadingStats={isLoading}
                    isStatic={true}
                    />

                    <Stats2
                    title={"Group "}
                    value={state.name}
                    isLoadingStats={isLoading}
                    isStatic={true}
                    />

                    <Stats2
                    title={"Linked camera count"}
                    value={state.cameraCount}
                    isLoadingStats={isLoading}
                    isStatic={true}
                    />

                  
                </div> 
  
                <br></br>
                {isLoading ? (
                  <div style={{ display: "flex", width: "100%" }}>
                    <DeviceLoadingGrid
                      CardCount={
                        20
                      }
                    />
                  </div>
                ) : (
                  <>
                    <div className={classes.searchContainer}>
                      {/* Search bar will go here */}
                      </div>
  
                      <BasicTable
                          data={loadedSites.data}
                          columns={tableColumns}
                          allColumns={tableColumns}
                          filtering={""}
                          rowClick={false}
                          ShowPagination={false}
                          PageSize={50000}
                          paginationOptions={[25, 50, 100]}
                          showFilterButton={false}
                          isSortable={false}
                        />
                  </>
                )}
  
                {/* <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center', 
                  textAlign: 'center',
                  marginTop:"15px"
                }}>
                  <Button style={{width: "30%"}}label="Load more" onClick={HandleLoadMore}/>
                </div> */}
              </div>
            </>
          )
        }}
      </Await>
    )
}

export default SiteCameras;

export async function camerasLoader({ params }) {
    const siteUUID = params.SiteUUID;
    const token = localStorage?.getItem('token');
    const client = localStorage?.getItem('client');

    return { 
        cameras: await getLiveViewCameras({ token, client }, siteUUID) };
}